import { VisitorID } from './components-new/visitor-id.js';
import { getBrowserType } from "./core/utils.js";
import { checkNewTabButtonTarget } from "./components-new/cta-new-tab.js";
import { initCampaign, setCampaignInfo } from "./components-new/journey-tracker.js";
import { trialButton } from "./components-new/trial-buttons.js";
import { waba } from "./components-new/waba-trigger.js";
import { checkChannelParams } from "./components-new/channel-params.js";
import { initCTAPartner } from "./components-new/cta-partner.js";
import { initWabaTracking } from "./components-new/utm-tracker.js"; // <--- tambahkan ini
import { ContactAutoTrack } from './components-new/auto-contact-track.js';
import { cta_trial_locale } from './components-new/cta-trial-locale.js';



(function () {
  'use strict';

  const visitorID = VisitorID.init();
  console.log('Current Visitor ID:', visitorID);

  function checkStickyWABA() {
    var stickyWABA = document.querySelector('.ic-wa');
    if(!stickyWABA) {
      var scrollTop = document.querySelector('#scroll-top');
      if(scrollTop) {
        scrollTop.classList.add('alt');
      }
    }
  }

  // Bind critical click handlers immediately so UX (loader/redirect) works
  // even if async tracking bootstrap fails or is slow.
  const runCoreInits = () => {
    try { checkStickyWABA(); } catch (e) {}
    try { getBrowserType(); } catch (e) {}
    try { checkNewTabButtonTarget(); } catch (e) {}
    try { waba(); } catch (e) {}
    try { trialButton(); } catch (e) {}
    // Ensure `user_journey` is created early (before first click).
    // We'll refresh it after initWabaTracking() to incorporate waba_code/wabac_code.
    try { initCampaign(); } catch (e) {}
    try { checkChannelParams(); } catch (e) {}
    try { initCTAPartner(); } catch (e) {}
    try { cta_trial_locale(); } catch (e) {}
  };

  // Campaign/journey computation should run after we have a chance to set
  // `waba_code` / `wabac_code` cookies via initWabaTracking().
  const runCampaignInit = () => {
    try { initCampaign(); } catch (e) {}
  };

  const refreshCampaignInfo = () => {
    // Force a recompute after WABA cookies are ready.
    try { setTimeout(() => { try { setCampaignInfo(); } catch (e) {} }, 0); } catch (e) {}
  };

  runCoreInits();

  initWabaTracking({
    csv: {
      mediumUrl: document.querySelector('#medium_file')?.value || '',
      campaignUrl: document.querySelector('#campaign_file')?.value || ''
    },
    ttlDays: 31,
    debug: false,
    channelCodes: {
      medium:   { 'organic direct': 'J7O', 'organic search': 'J6O' },
      campaign: { 'default': 'MJ' }
    }
  })
    .then(({ code, ccode, updated, source }) => {
      // console.log('WABA:', code, ccode, updated, source);
      runCampaignInit();
      refreshCampaignInfo();
      runCoreInits();
    })
    .catch((err) => {
      console.warn('[waba] initWabaTracking failed; continuing without it:', err);
      runCampaignInit();
      refreshCampaignInfo();
      runCoreInits();
    });

  ContactAutoTrack.init();  

})();